import React, { useCallback, useMemo, useState } from 'react';
import IndexTable from '@dex/bubl-dash/src/lib/components/IndexTable/IndexTable';
import LeagueSeasonTeamSettings from '../../LeagueSeasonTeam/LeagueSeasonTeamSettings';
import LeagueSeasonAddNewTeam from './LeagueSeasonAddNewTeam';
import Button from '@dex/bubl-dash/src/lib/components/Button/Button';

const LeagueSeasonManageTeams: React.FC<any> = (props: any) => {

    const { data } = props;

    const [key, setKey] = useState(0);

    const [showAddNew, setShowAddNew] = useState(false);

    const [tableState, setTableState] = useState({ search: undefined, where: undefined, order: undefined, skip: undefined });

    const preFetchFilters = useCallback((routeName, params, users) => {

        const filters = LeagueSeasonTeamSettings.indexFetchParams(routeName, params, users);

        filters.where.seasonId = data.id;

        return filters;

    }, []);

    const getColumns = useCallback((routeName, params, users) => {

        const columns = LeagueSeasonTeamSettings.indexColumns(routeName, params, users);

        // filters.where.seasonId = data.id;
        columns.map((column, index) => {

            if (column.key === "host") delete (columns[index]);
            else if (column.key === "season") delete (columns[index]);
            else if (column.key === "league") delete (columns[index]);
            else if (column.key === "created") delete (columns[index]);

            return column;

        });

        return columns;

    }, []);

    const handleClose = useCallback(() => {

        setKey(key + 1);
        setShowAddNew(false);

    }, [key])

    return useMemo(() => (

        <>

            <IndexTable
                key={key}
                title={"Teams"}
                getFetch={LeagueSeasonTeamSettings.indexFetch}
                getColumns={getColumns}
                preFetchFilters={preFetchFilters}
                getQuickSearch={LeagueSeasonTeamSettings.indexQuickSearch}
                getSearchFields={LeagueSeasonTeamSettings.indexSearchFields}
                routeParams={tableState}
                manageState={setTableState}
                hideTrashSwitch={true}
                actionButtons={() => (
                    <>
                        <Button
                            label={"Add New Team"}
                            size="small"
                            type="light"
                            onClick={setShowAddNew.bind(null, true)}
                        />
                    </>
                )}
            />

            {showAddNew &&
                <LeagueSeasonAddNewTeam
                    onClose={handleClose}
                    data={data}
                />
            }

        </>

    ), [data, tableState, key, showAddNew]);

}

export default LeagueSeasonManageTeams;
